module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//6.jpg?e89759bd8425aed02d9084254bb64e8a";